import React, { useRef } from "react";
import videoFile from "../images/zv.mp4";

const HeroSection = () => {
  const videoRef = useRef(null);

  return (
    <div className="hero-container">
      {/* ===== Inline CSS (Optimized) ===== */}
      <style>{`
        .hero-container {
          position: relative;
          width: 100%;
          height: 100vh;
          overflow: hidden;
          background: #000;
        }

        .hero-video {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: translateZ(0);
          will-change: transform;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.35);
          z-index: 1;
        }

        .hero-content {
          position: relative;
          z-index: 2;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          padding: 0 20px;
        }

        .hero-title {
          font-size: 3rem;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
          animation: fadeUp 1.2s ease-out both;
          line-height: 1.2;
        }

        .hero-word {
          display: inline-block;
          margin: 0 0.4rem;
          background: linear-gradient(90deg, #ffffff, #4bdfec);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-shadow: 0 0 12px rgba(75,223,236,0.4);
        }

        /* Tablet */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2.2rem;
          }
        }

        /* Mobile */
        @media (max-width: 480px) {
          .hero-container {
            height: 60vh;
          }

          .hero-title {
            font-size: 1.6rem;
          }
        }

        /* Very Small Devices (disable video for performance) */
        @media (max-width: 360px) {
          .hero-video {
            display: none;
          }

         
        

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      {/* ===== Background Video ===== */}
      <video
        ref={videoRef}
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
       
      >
        <source src={videoFile} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* ===== Overlay ===== */}
      <div className="hero-overlay" />

      {/* ===== Content ===== */}
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="hero-word">ZYNTRO</span>
          <span className="hero-word">SOFTWARE</span>
          <span className="hero-word">SOLUTION</span>
        </h1>
      </div>
    </div>
  );
};

export default HeroSection;
